import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import styled from 'styled-components';

const RootWrapper = styled.div`
    margin-bottom: 30px;
`;

const ListItemImageWrapper = styled.div`
    position: relative;
    border-radius: 4px;
`;

const ListItemImage = styled.div`
    min-height: 1px;
    width: 100%;

    & img,
    & svg {
        transition: opacity 125ms ease-in-out 450ms;
        position: absolute;
        height: 100%;
        width: 100%;
        opacity: 1;
    }
`;

const ImageSkeleton = styled(Skeleton)`
    padding-bottom: calc(4 / 3 * 100%);
    border-radius: 4px;
`;

const ListItemMeta = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ListItemText = styled.div`
    letter-spacing: 0.2px;
    line-height: 1.4;
    font-weight: 400;
    width: 80%;
`;

const ListItemLink = styled.div`
    padding-left: 5px;
    padding-top: 7px;
`;

const BrowseListItemSkeleton = () => (
    <RootWrapper>
        <ListItemImageWrapper>
            <ListItemImage>
                <ImageSkeleton variant="rect" />
            </ListItemImage>
        </ListItemImageWrapper>

        <ListItemMeta>
            <ListItemText>
                <Skeleton width={150} height={20} />
                <Skeleton width={100} height={20} />
            </ListItemText>

            <ListItemLink>
                <Skeleton variant="rect" width={25} height={25} style={{borderRadius: 4}} />
            </ListItemLink>
        </ListItemMeta>
    </RootWrapper>
);

export default React.memo(BrowseListItemSkeleton);
